import client from '../../../config/api';
import {
  LOCAL_SET_JOB_PHASES,
  LOCAL_ADD_JOB_PHASE,
  LOCAL_DELETE_JOB_PHASE,
  LOCAL_UPDATE_JOB_PHASE,
} from '../mutations/mutationTypes';

export default {
  async FETCH_JOB_PHASES({ commit }, { siteId }) {
    const result = await client.get(`/job-phases/site/${siteId}`);
    commit(LOCAL_SET_JOB_PHASES, result?.data || []);
  },

  async ADD_JOB_PHASE({ commit }, { siteId, phase }) {
    const result = await client.post(`/job-phases/site/${siteId}`, phase);
    commit(LOCAL_ADD_JOB_PHASE, result?.data || phase);
  },

  async DELETE_JOB_PHASE({ commit }, { siteId, phaseId }) {
    await client.delete(`/job-phases/site/${siteId}/${phaseId}`);
    commit(LOCAL_DELETE_JOB_PHASE, phaseId);
  },

  async SYNC_JOB_PHASES({ commit, rootState }, { jobId, phases }) {
    const result = await client.put(`/job-phases/job/${jobId}/phases`, {
      phases,
    });
    const updatedJob = { ...rootState.currentJob, jobPhases: result.data };
    commit('SET_CURRENT_JOB', updatedJob, { root: true });
    commit('JobsModule/SET_CURRENT_JOB', updatedJob, { root: true });
  },

  async HAS_TASKS_FOR_PHASE(_context, { jobId, phaseId }) {
    const normalizedPhaseId = String(phaseId || '').trim();

    const result = await client.get(`/task/job/${jobId}`, {
      params: {
        allTasks: true,
        ...(normalizedPhaseId ? { jobPhaseId: normalizedPhaseId } : {}),
      },
    });

    let tasks = [];
    if (Array.isArray(result?.data)) {
      tasks = result.data;
    } else if (Array.isArray(result?.data?.data)) {
      tasks = result.data.data;
    }

    if (!normalizedPhaseId) {
      return tasks.length > 0;
    }

    return tasks.some((task) => {
      const taskPhaseId = String(
        task?.jobPhaseId || task?.phaseId || ''
      ).trim();
      return taskPhaseId === normalizedPhaseId;
    });
  },

  async UPDATE_JOB_PHASE({ commit }, { siteId, phaseId, updates }) {
    const result = await client.put(
      `/job-phases/site/${siteId}/${phaseId}`,
      updates
    );
    commit(LOCAL_UPDATE_JOB_PHASE, {
      phaseId,
      updates: result?.data || updates,
    });
  },
};
